import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const unboxingVideoContentType = ["video/mp4", "video/webm"] as const;
export type UnboxingVideoContentType =
  (typeof unboxingVideoContentType)[number];

export const getUnboxingVideoUploadUrl = {
  name: "getUnboxingVideoUploadUrl" as const,
  input: z.object({
    returnId: zExt.objectId(),
    contentType: z.enum(unboxingVideoContentType),
  }),
  output: z.object({
    uploadUrl: z
      .string()
      .describe("Presigned S3 PUT URL the browser uploads the video to"),
    key: z.string().describe("S3 object key the video is stored at"),
  }),
};
